import { DEFAULT_LOCALE } from "constants/languages"

import { PromotionCategory, PromotionStatus } from "services/promotions/type"

import { PromotionFormState, TranslationForm } from "./types"

export const PROMOTION_CATEGORY_OPTIONS: { value: PromotionCategory; name: string }[] = [
  { value: "CASINO", name: "Casino" },
  { value: "SPORTS", name: "Sports" },
  { value: "VIP", name: "VIP" },
  { value: "FREEPLAY", name: "Free Cash" },
  { value: "NEWS", name: "News" }
]

export const PROMOTION_STATUS_OPTIONS: { value: PromotionStatus; name: string }[] = [
  { value: "DRAFT", name: "Draft" },
  { value: "PUBLISHED", name: "Published" },
  { value: "ARCHIVED", name: "Archived" }
]

export const emptyTranslation = (): TranslationForm => ({
  title: "",
  short_title: "",
  description: "",
  banner_image: null,
  thumbnail_image: null,
  blocks: []
})

export const EMPTY_PROMOTION_FORM: PromotionFormState = {
  slug: "",
  categories: [],
  status: "DRAFT",
  start_at: null,
  end_at: null,
  is_active: true,
  is_featured: false,
  game_ids: [],
  translations: {
    [DEFAULT_LOCALE]: emptyTranslation()
  }
}
